module.exports = __webpack_public_path__ + "img/veglogic-logo.85aad938.jpg";